module.exports = __webpack_public_path__ + "img/well-come-fit-logo.c3085509.png";